<app-patient-dashboard *ngIf="global.Role=='PATIENT'"></app-patient-dashboard>
<app-specialist-dashboard *ngIf="global.Role=='SPECIALIST'"></app-specialist-dashboard>
<app-admin-dashboard *ngIf="global.Role=='Admin'"></app-admin-dashboard>

